import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { Its2Constants } from '@apps/its2/its2.constants';
import { OpenPopinOriginator } from '@common/enum/open-popin-originator.enum';

@Component({
    selector: 'aa-incident',
    templateUrl: './incident.component.html',
    styleUrls: [
        './incident.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IncidentComponent
{
    @Input() openPopinOriginator: OpenPopinOriginator;
    @Input() commands: any[];

    constructor (
        private router: Router
    )
    { }

    createIncident ()
    {
        const route = this.commands ?? Its2Constants.CreateCaseRoute(this.openPopinOriginator);

        this.router.navigate(route);
    }
}
